<template>
  <b-card>
    <b-card-header class="pb-10">
      <b-card-title>Work Experience</b-card-title>
      <b-form-checkbox
        checked="false"
        class="custom-control-primary"
        name="check-button"
        switch
        inline
        @change="toggleCitizenShip"
      >
        <p v-if="citizenShip === 'i'">
          All </p>
        <p v-else-if="citizenShip === 'oci'">
          OCI
        </p>
      </b-form-checkbox>
    </b-card-header>
    <VueApexCharts
      height="400"
      type="bar"
      :options="options"
      :series="series[citizenShip]"
    />
  </b-card>
</template>

<script>
import {
  BCardHeader, BCardTitle, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    VueApexCharts,
  },
  props: {
    series: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      citizenShip: null,
      options: {
        colors: ['#163AB3', '#6681D9', '#AFC1FF'],
        plotOptions: {
          bar: {
            // columnWidth: '40%',
            backgroundBarRadius: 30,
            borderRadius: 30,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
        },
        // fill: {
        //   type: 'gradient',
        //   gradient: {
        //     opacityFrom: 0.8,
        //     opacityTo: 1,
        //   },
        // },
        chart: {
          id: 'Work Experience Column Chart',
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        xaxis: {
          categories: ['03/03-09/03', '10/03-16/03', '17/03-23/03', '24/03-30/03', '31/03-06/04', '07/04-13/04', '14/04-20/04', '21/04-27/04', '28/04-03/05'],
        },
      },
    }
  },

  mounted() {
    this.citizenShip = 'i'
  },

  methods: {
    toggleCitizenShip() {
      this.citizenShip = (this.citizenShip === 'oci') ? 'i' : 'oci'
    },
  },
}
</script>
